import { QuestionBase } from './question-base';

export class TextareaLargeQuestion extends QuestionBase<string> {
  controlType = 'textarea-large';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
